module.exports = __webpack_public_path__ + "img/zljslg-currency-guide-1.c269c277.png";